export const CONFIRM_CANCEL_SUBSCRIPTION_MODAL_NAME = 'confirmCancelSubscription'
